var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M21.5,24H2.5A2.507,2.507,0,0,1,0,21.5V4.505A2.508,2.508,0,0,1,2.5,2h18.99A2.508,2.508,0,0,1,24,4.505V21.5A2.506,2.506,0,0,1,21.5,24ZM2.505,4A.506.506,0,0,0,2,4.5V21.5a.5.5,0,0,0,.5.5H21.5a.5.5,0,0,0,.5-.5V4.5a.506.506,0,0,0-.5-.5H2.505ZM23,8H1A1,1,0,1,1,1,6H23a1,1,0,1,1,0,2ZM5,5A1,1,0,0,1,4,4V1A1,1,0,0,1,6,1V4A1,1,0,0,1,5,5ZM19,5a1,1,0,0,1-1-1V1a1,1,0,1,1,2,0V4A1,1,0,0,1,19,5Z",
    transform: "translate(0 0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 18)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 14)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 18)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 14)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 10)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(14 18)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(14 14)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(14 10)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(17 14)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(17 10)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 18)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 14)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 10)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.041e0a02.svg";
export { ForwardRef as ReactComponent };